
import { SysClock, tunableClock } from "./clock.js";
import { setContent, sendVC } from "./sockets/cs.js";
import { syncContentTime } from "./sockets/ts.js";
import { getWallClock } from "./sockets/wc.js";
import { checkInputs } from "./utils.js";
import { initIRPlayer, getPlayerInstance } from "@into-reality/player";
import { changeCamSyncxSlave } from "@into-reality/player";
import { eventInformations } from "./eventInformations.js";

export const IP = 'syncxserver.intoreality.tv';
export const WSPORT = '443';
//export const IP = '127.0.0.1';
//export const WSPORT = '9999';

// Relojes
export let sysclock = SysClock;
export let wallClock = tunableClock(sysclock, 1000000);

// Control de estado
export let master = false;
export let contador = 0;
export let ctUpdate;
export let cii;
export let NewRoom = false;
export let firstCII = true;

// Sockets
export let ws;
export let cii_ws;

// Referencia al <video>
export let video = null;

/**
 * Crea una nueva sala (newRoom) usando el event information seleccionado.
 */
export function newRoom() {
	master = true;

	let id = document.getElementById("inputSessionId").value;
	let eventIndex = document.getElementById("inputEvent").value;
	let selectedEvent = eventInformations[parseInt(eventIndex, 10)];
	let check = checkInputs(master, id, selectedEvent.sources_dash);
	if (check === 0) return;

	// Se abren los WebSockets
	ws = new WebSocket('wss://' + IP + ":" + WSPORT + "/" + id + "/new_con", 'echo-protocol');
	cii_ws = new WebSocket('wss://' + IP + ":" + WSPORT + "/" + id + "/dvbcsscii", 'echo-protocol');

	ws.onmessage = function(message) {
		if (message.data === 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx-exist') {
			alert("Room " + id + " already exists");
			return;
		} else {
			NewRoom = true;
		}
	};

	// Generar offset aleatorio para envío
	ctUpdate = parseFloat((Math.random() * 0.3 - 0.15).toFixed(3));

	cii_ws.onmessage = function(message) {
		cii = JSON.parse(message.data);

		if (cii.contentId === undefined) {
			setContent(cii, selectedEvent.sources_dash);
		}

		if (firstCII && cii.contentId !== undefined) {
			firstCII = false;

			// Sincronía y wallclock
			syncContentTime(cii, master);
			getWallClock(cii);

			window.isSyncX = true;
			initIRPlayer("syncx-player", selectedEvent);
			video = document.querySelector("#syncx-player_html5_api");
			addPlayerEvents();
		}
	};
}

/**
 * Únete a una sala (joinRoom).
 * Se buscará en eventInformations aquel que tenga sources_dash igual a cii.contentId.
 */
export function joinRoom(roomIdOverride) {
	let id = roomIdOverride
		? roomIdOverride
		: document.getElementById("inputSessionId").value;

	let check = 1;
	if (!roomIdOverride) {
		check = checkInputs(master, id);
		if (check === 0) return;
	}

	ws = new WebSocket('wss://' + IP + ":" + WSPORT + "/" + id + "/join", 'echo-protocol');
	cii_ws = new WebSocket('wss://' + IP + ":" + WSPORT + "/" + id + "/dvbcsscii", 'echo-protocol');

	ws.onmessage = function(message) {
		if (message.data === 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx-nonexist') {
			alert("Room '" + id + "' does not exist");
			return;
		} else {
			setSlaveUI();
		}
	};

	cii_ws.onmessage = function(message) {
		cii = JSON.parse(message.data);

		if (firstCII && cii.contentId != undefined) {
			firstCII = false;

			syncContentTime(cii, master);
			getWallClock(cii);

			// Se busca en la lista el eventInformation cuyo sources_dash coincida con cii.contentId
			const selectedEventInformation = eventInformations.find(
				info => info.sources_dash === cii.contentId
			);

			window.isSyncX = true;

			if (selectedEventInformation) {
				initIRPlayer("syncx-player", selectedEventInformation);
			} else {
				initIRPlayer("syncx-player", eventInformations[0]);
			}
			video = document.querySelector("#syncx-player_html5_api");

			if (document.readyState !== 'loading') {
				initVideoControlsModifier();
			} else {
				document.addEventListener('DOMContentLoaded', initVideoControlsModifier);
			}
		}
	};
}

function initVideoControlsModifier() {
	// Definimos los selectores de los elementos que se deben ocultar o eliminar
	const SELECTORES_OCULTAR = ".vjs-big-vr-play-button, .vjs-button-container";
	const SELECTORES_ELIMINAR = ".vjs-icon-info, .vjs-switch-audio-button, .vjs-subtitles-button, .vjs-switch-camera-button";

	// Para la barra de controles, indicamos qué botones deben seguir siendo visibles
	const SELECTORES_CONTROLBAR_VISIBLE = [
		".vjs-fullscreen-control",
		".vjs-button-vr",
		".vjs-switch-quality-button"
	];

	// Función para ocultar un elemento (añadiendo la clase "vjs-hidden" si aún no la tiene)
	function ocultarElemento(el) {
		if (!el.classList.contains("vjs-hidden")) {
			el.classList.add("vjs-hidden");
		}
	}

	// Procesa la barra de controles: ajusta su estilo y oculta los hijos que no deben verse
	function procesarControlBar(controlBar) {
		controlBar.style.flexDirection = "row-reverse";
		Array.from(controlBar.children).forEach(child => {
			const debeSerVisible = SELECTORES_CONTROLBAR_VISIBLE.some(selector =>
				child.matches(selector)
			);
			if (!debeSerVisible) {
				ocultarElemento(child);
			}
		});
	}

	// Función que procesa un elemento y sus descendientes:
	// - Si coincide con un selector de ocultar, se oculta.
	// - Si coincide con un selector de eliminar, se elimina.
	// - Si es la barra de controles, se procesa.
	function procesarElemento(el) {
		if (el.matches(SELECTORES_OCULTAR)) {
			ocultarElemento(el);
		}
		if (el.matches(SELECTORES_ELIMINAR)) {
			el.remove();
			return; // No procesamos sus hijos si se eliminó el elemento
		}
		if (el.matches(".vjs-control-bar")) {
			procesarControlBar(el);
		}

		// Procesamos los elementos descendientes que coincidan
		el.querySelectorAll(SELECTORES_OCULTAR).forEach(ocultarElemento);
		el.querySelectorAll(SELECTORES_ELIMINAR).forEach(elem => elem.remove());
		el.querySelectorAll(".vjs-control-bar").forEach(procesarControlBar);
	}

	// Buscamos el contenedor con la clase "intoreality-player"
	const container = document.querySelector(".intoreality-player");
	if (!container) {
		console.warn("No se encontró el contenedor '.intoreality-player'.");
		return;
	}

	// Realizamos un procesamiento inicial sobre el contenedor
	procesarElemento(container);

	// Configuramos un MutationObserver para vigilar únicamente el contenedor
	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			// Procesamos cada nodo añadido
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === Node.ELEMENT_NODE) {
					procesarElemento(node);
				}
			});
			// Además, si se modifican atributos de algún elemento, lo volvemos a procesar
			if (mutation.type === "attributes" && mutation.target.nodeType === Node.ELEMENT_NODE) {
				procesarElemento(mutation.target);
			}
		});
	});

	// Observamos el contenedor con las opciones necesarias
	observer.observe(container, {
		childList: true,
		subtree: true,
		attributes: true
	});
}

/**
 * Eventos para maestro.
 */
function addPlayerEvents() {
	contador = 0;

	video.ontimeupdate = function () {
		if (Math.abs(contador - video.currentTime) >= (1 + ctUpdate)) {
			if (!video.paused) {
				sendVC(cii, 'play', video.currentTime * 1000000000);
			}
			contador = video.currentTime;
		}
	};

	video.onseeked = function () {
		if (video.paused) {
			sendVC(cii, 'pause', video.currentTime * 1000000000);
		} else {
			sendVC(cii, 'play', video.currentTime * 1000000000);
		}
	};

	video.onpause = function () {
		sendVC(cii, 'pause', video.currentTime * 1000000000);
	};

	video.onvolumechange = function () {
		sendVC(cii, 'volume', 1000, video.volume);
	};

	function waitForXR() {
		const player = getPlayerInstance("syncx-player");

		if (!player) {
			setTimeout(waitForXR, 50);
			return;
		}

		const xr = player.xr();

		if (!xr || !xr.camera || !xr.camera.position) {
			setTimeout(waitForXR, 50);
			return;
		}

		let lastPosition = { x: xr.camera.position.x, y: xr.camera.position.y, z: xr.camera.position.z };

		setInterval(() => {
			const currentPosition = xr.camera.position;

			if (
				currentPosition.x !== lastPosition.x ||
				currentPosition.y !== lastPosition.y ||
				currentPosition.z !== lastPosition.z
			) {
				lastPosition = { x: currentPosition.x, y: currentPosition.y, z: currentPosition.z };
				changeCameraPosition(lastPosition);
			}
		}, 250);
	}

	waitForXR();
}

export function setSlaveUI() {
	// Lógica para el UI del slave (opcional)
}

export function changeCameraTrack(track) {
	if (master) {
		sendVC(cii, 'nextCamera', 10000, track);
	} else {
		changeCamSyncxSlave(track);
	}
}

export function changeAudioTrack(track) {
	if (master) {
		sendVC(cii, 'nextAudio', 10000, track);
	} else {
		const audioTracks = window.dashMediaPlayer.getTracksFor('audio');
		for (let i = 0; i < audioTracks.length; i++) {
			const audioName = audioTracks[i].lang || audioTracks[i].label || "Audio " + (i + 1);
			if (audioName === track) {
				window.dashMediaPlayer.setCurrentTrack(audioTracks[i]);
				break;
			}
		}
	}
}

export function changeCameraPosition(position) {
	if (master) {
		sendVC(cii, 'cameraPosition', 10000, position);
	} else {
		const player = getPlayerInstance("syncx-player");
		if (player && player.xr()) {
			player.xr().camera.position.set(position.x, position.y, position.z);
		}
	}
}

export function changeVolume(state) {
	if (video) {
		video.volume = state;
	}
}